import { I_Hotspot, I_Media } from '../types';

const hasMediaSource = (media?: I_Media | null) => Boolean(media?.src?.trim());

export const hotspotHasSound = (hotspot?: I_Hotspot) => {
  if (!hotspot) return false;

  if (hotspot.type === 'sound') {
    const soundFileSrc = hotspot.config?.sound?.file?.src?.trim();
    const directUrl = hotspot.config?.sound?.url?.trim();
    return Boolean(soundFileSrc || directUrl);
  }

  if (hotspot.type === 'instructor') {
    return Boolean(hotspot.config?.instructor?.media?.src?.trim());
  }

  if (
    hotspot.type === 'media' &&
    hotspot.config?.media?.type === 'media-video'
  ) {
    const hasVideoSrc = Boolean(
      hotspot.config?.media?.media?.src?.trim() ||
        hotspot.config?.media?.mediaIOS?.src?.trim(),
    );
    const autoPlayVideo = hotspot.config?.media?.autoPlay;
    const videoVolume = hotspot.config?.media?.volume ?? 0;

    return hasVideoSrc && Boolean(autoPlayVideo) && videoVolume > 0;
  }

  return false;
};

export const hasAnySceneSound = (params: {
  projectSound?: I_Media | null;
  sceneSound?: I_Media | null;
  hotspots?: I_Hotspot[] | null;
}) => {
  if (hasMediaSource(params.projectSound) || hasMediaSource(params.sceneSound))
    return true;

  return (params.hotspots || []).some(hotspotHasSound);
};

export const hasSceneBackgroundSound = (media?: I_Media | null) =>
  hasMediaSource(media);
